import { useState } from 'react';
import { API_URL, API_VERSION, SITE_URLS } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useCustomNavigate } from '@hooks/useCustomNavigate';

const ENDPOINT_URL = '/usr-favorites/store/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type RemoveFavoriteStoreInput = paths[url]['post']['parameters']['path'];

/**
 * Requests endpoint to remove a favorite store.
 */
export const useRemoveFavoriteStore = () => {
    const { navigate } = useCustomNavigate();
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [loading, setLoading] = useState<boolean>(false);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [error, setError] = useState<boolean>(false);

    const request = async (props: RemoveFavoriteStoreInput) => {
        setLoading(true);
        setError(false);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'DELETE',
                headers: getHeaders(),
                body: JSON.stringify(getCommonParameters()),
            });

            if (!response.ok) {
                const error = new Error() as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
                        
            if (error.statusCode === 401) {
                navigate(`/${SITE_URLS.login}`);
            }
            
            setError(true);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime };
};
